module.exports = __webpack_public_path__ + "static/media/qr-code-screen-1.4661355d.jpg";